import styled from "styled-components";
import { COLOR_MANIFEST_TEAL } from "../../styles/globalStylesVariables";

export const HighlightText = styled.span<{ $color: string }>`
  color: ${(props) => props.color || COLOR_MANIFEST_TEAL};
  font-size: inherit;
  font-weight: inherit;
  font-family: inherit;
`;
